import { useEffect, useState } from 'react';

// Nice, Côte d'Azur coordinates
const NICE_LAT = 43.7102;
const NICE_LON = 7.262;

// WMO Weather codes → atmosphere preset
// Reference: https://open-meteo.com/en/docs (variable: weather_code)
const mapCodeToAtmosphere = (code, isDay) => {
  if (!isDay) return 'night';
  if (code === 0) return 'clear';
  if ([1, 2].includes(code)) return 'partly';
  if (code === 3) return 'cloudy';
  if ([45, 48].includes(code)) return 'fog';
  if ([51, 53, 55, 56, 57, 61, 63, 65, 66, 67, 80, 81, 82].includes(code)) return 'rain';
  if ([71, 73, 75, 77, 85, 86].includes(code)) return 'snow';
  if ([95, 96, 99].includes(code)) return 'storm';
  return 'clear';
};

export const useNiceWeather = () => {
  const [weather, setWeather] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const url = `https://api.open-meteo.com/v1/forecast?latitude=${NICE_LAT}&longitude=${NICE_LON}&current=temperature_2m,weather_code,is_day&timezone=Europe%2FParis`;

    fetch(url)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (cancelled || !data || !data.current) return;
        const { temperature_2m, weather_code, is_day } = data.current;
        setWeather({
          temp: Math.round(temperature_2m),
          code: weather_code,
          isDay: is_day === 1,
          atmosphere: mapCodeToAtmosphere(weather_code, is_day === 1),
        });
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  return weather;
};
